
export function DemoCTASection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Ready to Protect Your Business?
          </h2>
          <p className="text-xl text-blue-100 mb-8 leading-relaxed">
            Start your 14-day free trial today. No credit card required, no setup fees. 
            Join 5,000+ UK businesses already protected by Driscop.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button className="bg-white text-blue-400 px-8 py-4 rounded-lg text-lg font-medium hover:bg-gray-700/50 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-rocket-line mr-2"></i>
              Start Free Trial
            </button>
            <button className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-calendar-line mr-2"></i>
              Book Personal Demo
            </button>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div className="text-white">
              <div className="text-2xl font-bold mb-2">14 Days</div>
              <div className="text-blue-100">Free Trial</div>
            </div>
            <div className="text-white">
              <div className="text-2xl font-bold mb-2">5 Minutes</div>
              <div className="text-blue-100">Setup Time</div>
            </div>
            <div className="text-white">
              <div className="text-2xl font-bold mb-2">24/7</div>
              <div className="text-blue-100">UK Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
